/* Harmony Cookies v1.2.0: flip cards and the day timeline (hc-flip-cards, hc-day) and the review track
   (hc-reviews, track layout). Ported from theme\_options\interactive\hc-int.js, option A and C parts left out.
   Included by more than one section, so it runs once only (the guard below). Progressive: without this file every panel, card face,
   slide and review is already in the page and readable. Reduced motion: scrolling is instant here, and
   hc-base.css removes every CSS transition. */
(function () {
  'use strict';
  if (window.__hcInt) return; window.__hcInt = true;
  var rm = window.matchMedia('(prefers-reduced-motion: reduce)');
  var beh = function () { return rm.matches ? 'auto' : 'smooth'; };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var padL = function (el) { return parseFloat(getComputedStyle(el).paddingLeft) || 0; };
  var nearest = function (track, items) {
    var x = track.scrollLeft, best = 0, d = Infinity;
    if (x >= track.scrollWidth - track.clientWidth - 2 && x > 0) return items.length - 1; // at the end: the last item
    items.forEach(function (it, k) { var dd = Math.abs(it.offsetLeft - padL(track) - x); if (dd < d) { d = dd; best = k; } });
    return best;
  };

  /* ---- review track (all options) ---- */
  $$('[data-rev-track]').forEach(function (track) {
    var sec = track.closest('section'), prev = $('[data-rev-prev]', sec), next = $('[data-rev-next]', sec);
    var cards = $$('.int-card', track);
    var sync = function () {
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.setAttribute('aria-disabled', track.scrollLeft <= 2 ? 'true' : 'false');
      next.setAttribute('aria-disabled', track.scrollLeft >= max ? 'true' : 'false');
    };
    var go = function (dir) {
      var k = Math.max(0, Math.min(cards.length - 1, nearest(track, cards) + dir));
      track.scrollTo({ left: cards[k].offsetLeft - padL(track), behavior: beh() });
    };
    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', sync, { passive: true });
    sync();
  });

  /* ---- B: flip cards ---- */
  $$('[data-fc]').forEach(function (card) {
    var btn = $('.fc-btn', card), lab = $('[data-fc-l]', card), front = $('.fc-front', card), back = $('.fc-back', card);
    back.inert = true;
    btn.addEventListener('click', function () {
      var on = !card.classList.contains('is-flipped');
      card.classList.toggle('is-flipped', on);
      btn.setAttribute('aria-expanded', on ? 'true' : 'false');
      lab.textContent = on ? (btn.getAttribute('data-back') || 'Turn back') : (btn.getAttribute('data-over') || 'Turn over'); // labels from the theme's locale
      front.inert = on; back.inert = !on;
    });
  });

  /* ---- B: the day timeline ---- */
  var day = $('[data-day-track]');
  if (day) {
    var lock = 0, slides = $$('.day-slide', day), chips = $$('[data-day-chip]'), dots = $$('.day-dot');
    var mark2 = function (k) {
      chips.forEach(function (c, i) { if (i === k) c.setAttribute('aria-current', 'true'); else c.removeAttribute('aria-current'); });
      dots.forEach(function (d, i) { d.classList.toggle('is-on', i === k); });
    };
    chips.forEach(function (c, k) {
      c.addEventListener('click', function (e) {
        e.preventDefault();
        lock = Date.now(); // a chip-driven scroll keeps the chip's choice, even where the track end shows two slides
        day.scrollTo({ left: slides[k].offsetLeft - padL(day), behavior: beh() });
        mark2(k);
      });
    });
    var tick = null;
    day.addEventListener('scrollend', function () { lock = 0; });
    day.addEventListener('scroll', function () { if (tick || (lock && Date.now() - lock < 1200)) return; tick = requestAnimationFrame(function () { tick = null; mark2(nearest(day, slides)); }); }, { passive: true });
  }

})();
